<script setup>
import { useLoaderStore } from './stores/loaderStore';
const loaderStore = useLoaderStore();
</script>

<template>
    <router-view></router-view>
    <div class="loader" v-if="loaderStore.loader">
        <img src="/assets/images/spinner-v2.png" alt="loader" />
    </div>
    <div class="rotate-overlay">
        <div class="rotate-overlay__content">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="4" y="2" width="16" height="20" rx="2" />
                <path d="M12 18h.01" />
            </svg>
            <p>Ruota il dispositivo in orizzontale per usare l'applicazione</p>
        </div>
    </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

/* Show rotate prompt on tablet-sized screens in portrait mode */
.rotate-overlay {
    display: none;
}

@media (min-width: 768px) and (max-width: 1366px) and (orientation: portrait) and (hover: none) and (pointer: coarse) {
    .rotate-overlay {
        display: flex;
        position: fixed;
        inset: 0;
        z-index: 99999;
        background-color: #fff;
        justify-content: center;
        align-items: center;
    }
}

.rotate-overlay__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    padding: 2rem;
    text-align: center;
    color: #374151;
}

.rotate-overlay__content svg {
    width: 80px;
    height: 80px;
    color: #6b7280;
    animation: rotate-hint 2s ease-in-out infinite;
}

.rotate-overlay__content p {
    font-size: 1.125rem;
    font-weight: 500;
    max-width: 280px;
    line-height: 1.6;
}

@keyframes rotate-hint {
    0%, 100% { transform: rotate(0deg); }
    40%       { transform: rotate(90deg); }
    60%       { transform: rotate(90deg); }
}

.loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    opacity: 0.7;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
